import type { PropsWithChildren } from "react"
import React, { useEffect } from "react"

import { useAuth } from "~utils/hooks/use-auth"
import { getFullRoute } from "~utils/helpers/navigation-helpers"
import AuthenticatingLoader from "~components/shared/loader/authenticating-loader"

const SIGNUP_SCREEN_HINT = "signup"

interface Props extends PropsWithChildren {
    readonly isSignupDefault?: boolean
    readonly shouldRequireAuth?: boolean
}

export default function WithAuthentication({
    isSignupDefault,
    shouldRequireAuth = true,
    children,
}: Props) {
    const { isLoading, isAuthenticated, loginWithRedirect } = useAuth()

    const screenHint = isSignupDefault ? SIGNUP_SCREEN_HINT : undefined
    const isAuthenticatedIfNecessary = !shouldRequireAuth || isAuthenticated
    const shouldRenderChildren = isAuthenticatedIfNecessary && !isLoading

    useEffect(() => {
        if (isLoading || isAuthenticated || !shouldRequireAuth) return

        void loginWithRedirect({
            appState: { returnTo: getFullRoute() },
            authorizationParams: {
                screen_hint: screenHint,
            },
        })
    }, [isLoading, isAuthenticated, shouldRequireAuth])

    return shouldRenderChildren ? children : <AuthenticatingLoader />
}
